export default __webpack_public_path__ + "static/media/anikomezosi960.7fdbdb5f.jpg";